import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin, Navigation } from "lucide-react";
import Reveal from "./Reveal";
import { mapsLink } from "../data/siteData";

export default function StoreCard({ store, index }) {
  return (
    <Reveal delay={index * 0.1}>
      <article
        data-testid={`store-card-${store.id}`}
        className="group card-soft flex h-full flex-col overflow-hidden transition-shadow duration-300 hover:shadow-[0_16px_40px_-10px_rgba(0,168,89,0.18)]"
      >
        <Link to={store.slug} className="relative block overflow-hidden" tabIndex={-1} aria-hidden="true">
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={store.image}
              alt={`${store.name} — ${store.city}`}
              loading="lazy"
              style={{ objectPosition: store.imagePosition || "center" }}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </div>
          {store.open247 && (
            <span className="absolute left-4 top-4 rounded-full bg-brand px-3 py-1 font-display text-[11px] font-bold uppercase tracking-widest text-white shadow-lg">
              Aperto 24/7
            </span>
          )}
        </Link>

        <div className="flex flex-1 flex-col p-6">
          <p className="overline-tag">{String(index + 1).padStart(2, "0")} — {store.city}</p>
          <h3 className="mt-2 font-display text-xl font-bold uppercase tracking-tight text-ink sm:text-2xl">
            {store.name}
          </h3>
          <p className="mt-2 flex items-start gap-2 text-sm text-slate-500">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            {store.address}, {store.city}
          </p>
          <p className="mt-1.5 flex items-center gap-2 text-sm text-slate-500">
            <Clock className="h-4 w-4 shrink-0 text-brand" />
            {store.hoursSummary}
          </p>

          <div className="mt-6 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
            <a
              href={mapsLink(store.fullAddress)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`card-gmaps-${store.id}`}
              className="btn btn-outline btn-sm w-full"
            >
              <Navigation className="h-4 w-4" />
              INDICAZIONI
            </a>
            <Link to={store.slug} data-testid={`card-view-${store.id}`} className="btn btn-primary btn-sm w-full">
              SCOPRI LA SEDE
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </article>
    </Reveal>
  );
}
